//
// WindowSize.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var WindowSize = {
    DEFAULT:0,
    SMALL:1,
    MEDIUM:2,
    LARGE:3
};
export default WindowSize;
